import { AxiosResponse } from 'axios';
import instance from '../../api/instance';
import { CompanyServiceProvider, NewServiceProvider } from './types';

export type GetCompanyServiceProviders = (params: {
  companyId: string;
}) => Promise<AxiosResponse<CompanyServiceProvider[]>>;

export const getCompanyServiceProviders: GetCompanyServiceProviders = async ({ companyId }) => {
  return instance.get(`companies/${companyId}/service-providers`).catch(e => e.response as never);
};

export type PostNewCompanyServiceProvider = (params: {
  companyId: string;
  data: NewServiceProvider;
}) => Promise<AxiosResponse<CompanyServiceProvider>>;

export const postNewCompanyServiceProvider: PostNewCompanyServiceProvider = async ({ companyId, data }) => {
  return instance.post(`companies/${companyId}/service-providers`, data).catch(e => e.response as never);
};

export type DeleteCompanyServiceProvider = (params: {
  companyId: string;
  providerId: string;
}) => Promise<AxiosResponse<void>>;

export const deleteCompanyServiceProvider: DeleteCompanyServiceProvider = async ({ companyId, providerId }) => {
  return instance.delete(`companies/${companyId}/service-providers/${providerId}`).catch(e => e.response as never);
};
